import { render, staticRenderFns } from "./FlatCodesView.vue?vue&type=template&id=07cf1f48&lang=pug&"
import script from "./FlatCodesView.vue?vue&type=script&lang=ts&"
export * from "./FlatCodesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports